import { Dialog, DialogTitle } from "@mui/material";
import MultiPartChildForm from "./MultiPartChildForm";
import Translate from "../../utils/Translate";

export default function MultiPartChildDialog(props) {
  console.log("multipartdialog", props);
  return (
    <Dialog open className="smallCourseDialog">
      <DialogTitle>{Translate.get("AddChild")}</DialogTitle>
      <MultiPartChildForm {...props} />
    </Dialog>
  );
}
